var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10 1.25A4.75 4.75 0 0 0 5.25 6v4.25h-2v8.5h13.5v-8.5h-2V6A4.75 4.75 0 0 0 10 1.25m3.25 9V6a3.25 3.25 0 0 0-6.5 0v4.25zm-8.5 1.5v5.5h10.5v-5.5z",
    clipRule: "evenodd"
  })));
};
export { SvgLock as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCAxLjI1QzcuMzc2NjUgMS4yNSA1LjI1IDMuMzc2NjUgNS4yNSA2VjEwLjI1SDMuMjVWMTguNzVIMTYuNzVWMTAuMjVIMTQuNzVWNkMxNC43NSAzLjM3NjY1IDEyLjYyMzQgMS4yNSAxMCAxLjI1Wk0xMy4yNSAxMC4yNVY2QzEzLjI1IDQuMjA1MDcgMTEuNzk0OSAyLjc1IDEwIDIuNzVDOC4yMDUwNyAyLjc1IDYuNzUgNC4yMDUwNyA2Ljc1IDZWMTAuMjVIMTMuMjVaTTQuNzUgMTEuNzVWMTcuMjVIMTUuMjVWMTEuNzVINC43NVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";